import React, { useEffect, useRef } from 'react';
import { useHistory } from 'react-router';

const useRedirectIfNoData = (path = '/login') => {
    const user = JSON.parse(localStorage.getItem('user'));
    const history = useHistory();

    useEffect(() => {
        if (!user || user <= 0) {
            history.push(path);
        }
    }, [history, path]);

    useEffect(() => {
        if (!user || user <= 0) {
            history.push(path);
        }
    }, []);

    return;
};

export default useRedirectIfNoData;